import React from 'react';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-body">
        <p className="title">
          Unlocking Potential, Driving Growth.
        </p>
        <p className="subtitle">
          Your expert partner in Cloud and AI transformation.
        </p>
      </div>
    </section>
  );
};

export default Hero;
